import { makeStyles } from 'tss-react/mui';

const useStylesLoader: MaterialUIStylesCallback = makeStyles()((): MaterialUIStyles => ({
  loader: {
    position: 'absolute',
    height: '100%',
    width: 'calc(100% - 20px)',
  },
  loaderInline: {
    position: 'relative',
    width: 'auto',
    height: 'auto',
  },
  loaderFloating: {
    position: 'absolute',
  },
  loaderPage: {
    position: 'relative',
    width: 'auto',
    height: 'calc(100vh - 40px - 64px - 20px)',
  },
  loaderPageTopOffset: {
    height: 'calc(100vh - 40px - 64px - 48px - 60px - 20px)',
  },
  loaderSubmit: {
    marginTop: 10,
    marginLeft: 10,
  },
  loaderModal: {
    top: 10,
  },
  loaderModalSubmit: {
    marginTop: -10,
    top: 'auto',
  },
  loaderHidden: {
    display: 'none !important',
  },
  loaderProgressSmall: {
    width: '30px !important',
    height: '30px !important',
  },
  loaderProgress: {
    margin: 10,
  },
}));

export default useStylesLoader;
